<template>
  <div>
    <div :style="imageDivStyling">

      <div  class="overflow-draggable-div">
        <div :style="{height: (100 * scale) + 10 + 'px', width: (100 * scale) + 10 + 'px', margin: 0 + 'px !important'}" v-for="(item, index) in questionData.mappedLocations" :key="index">
          <div :id="'draggableimagediv_' + index">
            <img
              :style="{ width: 100 * scale + 'px', height: 100 * scale + 'px', overflow: 'visible'} " 
              :src="item.draggableImageUrl">
          </div>
        </div>
      </div>

    </div>
      <vs-divider style="padding-top: 10px"></vs-divider>

    <!-- <canvas id="studentCanvas" :style="previewCanvasStyle"></canvas> -->

    <div class="canvas-div-drag-and-drop">
      <canvas 
        id="studentCanvas" 
        ref="studentCanvasRef"
        :width="canvasWidth" 
        :height="canvasHeight" 
        :style="canvasBackgroundStyle"
        class="student-canvas-background"
        >
      </canvas>
    </div>
    

  </div>
</template>

<script>
  import index from 'vue-youtube-embed';
  import Draggable from './draggable';
  import jQuery from './jquery';
  import canvas from './jquery.canvasAreaDrawDragAndDrop';

  export default {
    components: {

      },
    data() {
      return {
        mappedLocations: {},
        canvasHeight: '',
        canvasWidth: '',
        scale: 0,
        windowWidth: window.innerWidth,
        fixWidth: false,
        canvasStyle: '',
        canvasBackgroundStyle: '',
        imageDivStyling: "img { height: (100 * scale) + 'px', width: (100 * scale) + 'px' , overflow: 'visible'}"
      }
    },
    computed: {
      
    },
    watch: {
      windowHeight(newHeight, oldHeight) {
        this.setScale();
      }
    },
    methods: {
      showBlocksOnCanvas(){
        var self = this;     
        var canvas = document.getElementById("studentCanvas");

        if (canvas.getContext) {
          var ctx = canvas.getContext("2d");

          self.setScale();

          self.questionData.mappedLocations.forEach(element => {
            ctx.strokeStyle = element.color;
            ctx.strokeRect(parseInt(element.xCoordinate * self.scale), parseInt(element.yCoordinate * self.scale), parseInt(100 * self.scale) , parseInt(100 * self.scale));
            ctx.stroke();
          });

          if(self.isMobile()){
            self.canvasBackgroundStyle = { background: 'url(' + self.questionData.imageUrl + ')', width: '200%' };
          } else {
            self.canvasBackgroundStyle = { background: 'url(' + self.questionData.imageUrl + ')' };
          }
        }
      },
      makeImagesDraggable(){
        var self = this;

        window.d = [];

        self.questionData.mappedLocations.forEach(function arrayToImage(element, index){
          var localElement = document.getElementById('draggableimagediv_' + index);
        
          var options = {
            onDragEnd: self.onDragEndFunction(self),
            onDragStart:  self.onDragStartFunction(self),
            setCursor: true
          };

          window.d[index] = new Draggable (localElement, options);

          document.getElementById('draggableimagediv_' + index).style["position"] = "relative";
          document.getElementById('draggableimagediv_' + index).style["inset"] = "unset";

          document.getElementById('draggableimagediv_' + index).style["top"] = "0px";
          document.getElementById('draggableimagediv_' + index).style["bottom"] = "unset";
          document.getElementById('draggableimagediv_' + index).style["left"] = "unset";
          document.getElementById('draggableimagediv_' + index).style["right"] = "unset";
        });
      },
      onDragStartFunction (myself) {
        return function (element, x, y) {
          element.style["position"] = "absolute";
        };
      },
      onDragEndFunction (myself) {
        return function (element, x, y) {

          const between = (x, min, max) => {
            return x >= min && x <= max;
          }

          var imageNumber = element.id.substring(18, element.id.length);

          myself.questionData.mappedLocations[imageNumber].xCoordinates = x - myself.$refs.studentCanvasRef.offsetLeft;
          myself.questionData.mappedLocations[imageNumber].yCoordinates = y - myself.$refs.studentCanvasRef.offsetTop;

          var xCo = myself.questionData.mappedLocations[imageNumber].xCoordinates;
          var yCo = myself.questionData.mappedLocations[imageNumber].yCoordinates;

          var itFits = false;

          myself.questionData.mappedLocations.forEach(function arrayToImage(elementLocal, index){
            myself.setScale();

            var scale = myself.scale;

            if(between(xCo, (elementLocal.xCoordinate * scale)  - 50, (elementLocal.xCoordinate * scale) + 50) 
              && between(yCo, (elementLocal.yCoordinate * scale) - 50, (elementLocal.yCoordinate * scale) + 50)){
              window.d[imageNumber].set((elementLocal.xCoordinate * scale) + myself.$refs.studentCanvasRef.offsetLeft , (elementLocal.yCoordinate * scale) + myself.$refs.studentCanvasRef.offsetTop);

              myself.questionData.mappedLocations[imageNumber].xCoordinates = x - myself.$refs.studentCanvasRef.offsetLeft;
              myself.questionData.mappedLocations[imageNumber].yCoordinates = y - myself.$refs.studentCanvasRef.offsetTop;
              itFits = true;
              element.style["position"] = "absolute";
            }

            if(!itFits){
              element.style["position"] = "relative";
              element.style["inset"] = "unset";
              element.style["top"] = "0px";
              element.style["bottom"] = "unset";
              element.style["left"] = "unset";
              element.style["right"] = "unset";
            }
          });
        }
      },
      setScale(){
        var self = this;

        if(self.isMobile()){
          var origionalImgWidth = self.questionData.imageUrlWidth;

          var currentWidth = $('canvas')[0].clientWidth / 2;

          self.scale = currentWidth / origionalImgWidth;
        }
      },
      onResize() {
        this.setScale();
      }
    },
    created(){
      this.questionData = JSON.parse(localStorage.getItem("questionData"));

      window.addEventListener('resize', this.onResize);
    },
    beforeDestroy() { 
      window.removeEventListener('resize', this.onResize); 
    },
    mounted(){
      var self = this;

      if(!self.isMobile()){
        self.canvasHeight = self.questionData.imageUrlWidth + 'px';
        self.canvasWidth = self.questionData.imageUrlWidth + 'px';
        self.scale = 1;
        setTimeout(() => {
          self.makeImagesDraggable();
          setTimeout(() => {
            self.showBlocksOnCanvas();
          }, 70);
        }, 69);
      } else {
        setTimeout(() => {
          self.setScale();
          self.makeImagesDraggable();
          setTimeout(() => {
            self.showBlocksOnCanvas();
          }, 70);
          setTimeout(() => {
            self.setScale();
          }, 100);
        }, 69);
      }

      window.addEventListener('resize', this.onResize);
    }
  }

</script>

<style lang="scss">

.h-scroll{
  margin: 4px, 4px;
  padding: 4px;
  background-color: #08c708;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}

.student-canvas-background{
  background-size: contain !important;
  background-repeat: no-repeat !important;
}

.overflow-draggable-div{
  display: flex;
  overflow-x: auto;
  width: 100%;
}

</style>
